import { render } from "./NcDragList.vue?vue&type=template&id=a3ecc2ae"
import script from "./NcDragList.vue?vue&type=script&lang=js"
export * from "./NcDragList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__